import { FeedItem } from "ztypes/feed";
import api, { IResponse } from "./http-common";

class HomeService {
  getAuth = async () => {
    const res = await api.get<IResponse>(`/auth`);
    return res;
  };

  getFeed = async (fid: string | null) => {
    const res = await api.get<IResponse>(`/feed`, {
      params: { fid: fid },
    });
    return res;
  };

  getFeedV2 = (fid: string | null) => {
    const resp = api
      .get<FeedItem>(`/feed`, {
        params: { fid: fid },
      })
      .then((resp) => {
        return resp.data;
      })
      .catch((e) => {
        return null;
      });
    return resp;
  };

  checkZba = (fid: string | null) => {
    const resp = api
      .get<any>(`/zba/check`, {
        params: { fid: fid },
      })
      .then((resp) => {
        return resp.data;
      })
      .catch((e) => {
        return null;
      });
    return resp;
  };

  upgradeZba = (fid: string | null) => {
    const resp = api
      .post<any>(`/zba/upgrade`, null, {
        params: { fid: fid },
      })
      .then((resp) => {
        return resp.data;
      })
      .catch((e) => {
        return null;
      });
    return resp;
  };
}

export default new HomeService();
